<template>
    <div class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

        <!-- Year Confirmation Modal -->
        <div v-if="!showEmailModal" class="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden">
            <!-- Header -->
            <div class="bg-yellow-100 border-b border-orange-200 px-6 py-5">
                <div class="flex items-center gap-3">
                    <div class="h-12 w-12 rounded-full bg-yellow-400 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" 
                            stroke-linejoin="round" class="lucide lucide-circle-alert h-6 w-6 text-yellow-600" 
                            aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><line x1="12" x2="12" 
                            y1="8" y2="12"></line><line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                    </div>
                    <h3 class="text-gray-900 font-bold"> You are signing up for the {{ currentYear }} protest season</h3>
                </div>
            </div>

            <!-- Body -->
            <div class="p-6">
                <div class="space-y-4 mb-14 text-gray-700 text-left">
                    <p>Protests are filed on the appraisal district’s proposed tax value for your home, shown on the value notice, not the tax bill.</p>
                    <p>When your tax value notice is released mid to late April, we will email you a link to the appraisal district’s notice showing your proposed tax value, and ask you to acknowledge that you received it.
                    </p>
                    <p>To sign up for {{ currentYear }}, click Continue for {{ currentYear }} below.</p>
                    
                </div>  
                <!-- Actions -->
                <div class="flex flex-col gap-3 justify-end sm:flex-row">
                    <button class="rounded-md border px-4 py-2 h-9 text-sm" @click="openEmailModal">
                        Not now
                    </button>

                    <button class="rounded-md bg-indigo-600 px-4 py-2 h-9 text-sm font-semibold text-white hover:bg-indigo-700" @click="$emit('confirm')">
                        Continue for {{ currentYear }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Email Modal -->
        <registration-interest-email-modal v-if="showEmailModal" @submitted="handleEmailSubmit" @close="closeAll" />
    </div>
</template>


<script>
import { registrationYear } from '../../../../../config/base';
import RegistrationInterestEmailModal from './RegistrationInterestEmailModal.vue';

export default {
    components: {
        RegistrationInterestEmailModal,
    },

    emits: ['confirm', 'close'],

    data() {
        return {
            currentYear: registrationYear,
            showEmailModal: false,
        };
    },

    methods: {
        openEmailModal() {
            this.showEmailModal = true;
        },

        handleEmailSubmit(form) {
            this.$emit('email-submitted', form);
            this.closeAll();
        },

        closeAll() {
            this.showEmailModal = false;
            this.$emit('close');
        },
    },
};
</script>
